"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuitChannelDTO = exports.JoinChannelDTO = exports.UserChangeDTO = exports.ChannelSocketEventDTO = exports.ChannelDTO = exports.ChannelSocketEventCsharpTypes = exports.UserChangeTypes = void 0;
const class_validator_1 = require("class-validator");
var UserChangeTypes;
(function (UserChangeTypes) {
    UserChangeTypes["UserJoin"] = "UserJoin";
    UserChangeTypes["UserQuit"] = "UserQuit";
})(UserChangeTypes = exports.UserChangeTypes || (exports.UserChangeTypes = {}));
var ChannelSocketEventCsharpTypes;
(function (ChannelSocketEventCsharpTypes) {
    ChannelSocketEventCsharpTypes["UserChange"] = "LoneStoneStudio.CityInvaders.UserChangeDTO, CityInvaders.Runtime";
})(ChannelSocketEventCsharpTypes = exports.ChannelSocketEventCsharpTypes || (exports.ChannelSocketEventCsharpTypes = {}));
class ChannelDTO {
}
exports.ChannelDTO = ChannelDTO;
class ChannelSocketEventDTO {
}
exports.ChannelSocketEventDTO = ChannelSocketEventDTO;
class UserChangeDTO extends ChannelSocketEventDTO {
    constructor() {
        super(...arguments);
        this.$type = ChannelSocketEventCsharpTypes.UserChange;
        this.userChangeType = UserChangeTypes.UserJoin;
    }
}
exports.UserChangeDTO = UserChangeDTO;
let JoinChannelDTO = (() => {
    class JoinChannelDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], JoinChannelDTO.prototype, "channelId", void 0);
    return JoinChannelDTO;
})();
exports.JoinChannelDTO = JoinChannelDTO;
let QuitChannelDTO = (() => {
    class QuitChannelDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], QuitChannelDTO.prototype, "channelId", void 0);
    return QuitChannelDTO;
})();
exports.QuitChannelDTO = QuitChannelDTO;
//# sourceMappingURL=Channel.js.map